import React, { VFC } from 'react';
import { Ul } from './styles';

import useMaxAmountOfTokens from '../../hooks/common/useMaxAmountOfTokens';

const Notice: VFC = () => {
  const maxAmountOfTokens = useMaxAmountOfTokens(`all`);

  return (
    <Ul>
      <li>The K STADIUM bridge connects wallets of differing networks.</li>
      <li>Confirmation from the wallet is needed to complete transaction.</li>
      <li>Please check the tax and bridge fee before proceeding.</li>
      <li>
        Please consider fees when entering amount or your transaction may fail.
        In case of Groundchain to Ethereum transfer, max amount is automatically
        calculated excluding fees(-1 for total convertible amount).
      </li>
      <li>
        Please check the amount in the recipient wallet before confirming
        transaction.
      </li>
      <li>
        <span>
          Please contact the K STADIUM help center to convert amounts higher
          than
          <span className="text-bold">{maxAmountOfTokens}</span>
        </span>
      </li>
      <li>
        Bridge fees and large amount conversion policy may change depending on
        the market situation.
      </li>
    </Ul>
  );
};

export default Notice;
